import { styled } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import {
  ACCOUNTING_PAGE,
  ESTATE_PAGE,
  OFFERS_AND_SERVICES_PAGE,
  PAYMENTS_PAGE,
  DASHBOARD_PAGE,
  TICKETS_PAGE,
  DOCUMENTS_PAGE,
  GENERAL_ASSEMBLY_PAGE,
  TENANTS_BALANCE_PAGE,
  ariaLabel,
  COUNCIL_PAGE,
} from "src/constants";
import ContentPageWrapper from "src/containers/ContentPageWrapper";
import { BrandCodeEnum } from "src/graphql/generated/types";
import { useBrand, useCurrentAccount } from "src/hooks";

import { LinksGrid } from "./_components/Grid";

const StyledLink = styled(Link)<{ $isPrimaryBrand: boolean }>`
  color: ${(props) =>
    props.$isPrimaryBrand ? props.theme.palette.blue.main : props.theme.palette.primary.main};
  font-weight: 700;
  font-size: 24px;
  text-decoration: underline;
  text-underline-offset: 6px;
  text-decoration-thickness: 1px;
`;

type LinkType = {
  label: string;
  path: string;
};

type LinkTypeList = Array<LinkType>;

const SiteMapPage = () => {
  const currentAccount = useCurrentAccount();
  const { code } = useBrand();
  const isPrimaryBrand = code === BrandCodeEnum.Foncia;

  const links: LinkTypeList = [
    { label: ariaLabel.dashboardTitle, path: DASHBOARD_PAGE },
    { label: ariaLabel.ticketsTitle, path: TICKETS_PAGE },
    { label: ariaLabel.accountingTitle, path: ACCOUNTING_PAGE },
    { label: ariaLabel.offersAndServicesTitle, path: OFFERS_AND_SERVICES_PAGE },
    { label: ariaLabel.estateTitle, path: ESTATE_PAGE },
    { label: ariaLabel.documentsTitle, path: DOCUMENTS_PAGE },
  ];
  if (currentAccount.__typename === "CoownerAccount") {
    links.splice(3, 0, { label: ariaLabel.paymentsTitle, path: PAYMENTS_PAGE });
    links.splice(5, 0, { label: ariaLabel.councilTitle, path: COUNCIL_PAGE });
    links.push({ label: ariaLabel.generalAssemblyTitle, path: GENERAL_ASSEMBLY_PAGE });
  }
  if (currentAccount.__typename === "LandlordAccount") {
    links.splice(4, 0, { label: ariaLabel.tenantsBalanceTitle, path: TENANTS_BALANCE_PAGE });
  }
  if (currentAccount.__typename === "TenantAccount") {
    links.splice(3, 0, { label: ariaLabel.paymentsTitle, path: PAYMENTS_PAGE });
  }
  return (
    <ContentPageWrapper title="Plan de site">
      <LinksGrid>
        {links.map((link, index) => (
          <StyledLink key={index} to={`../${link.path}`} $isPrimaryBrand={isPrimaryBrand}>
            {link.label}
          </StyledLink>
        ))}
      </LinksGrid>
    </ContentPageWrapper>
  );
};

export default SiteMapPage;
